module.exports = __webpack_public_path__ + "img/about.9a83a0e5.png";